import { HttpService } from "./HttpService";
import axios from "axios";

export class ApiService extends HttpService {
  constructor() {
    const instance = axios.create({
      baseURL: `${process.env.NEXT_PUBLIC_VERZEL_FUNCTIONS_HOST}`,
    });

    super(instance);
  }

  async makeHttpRequest(config) {
    return super.makeHttpRequest(config);
  }

  async handleRequestError(e, config) {
    if (e.response.status !== 401) {
      return super.handleRequestError(e, config);
    }
  }
}
